import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'top-finder-selectboxes',
    label: 'topdata-topfinder.selectboxes.adminLabel',
    category: 'commerce',
    component: 'sw-cms-block-top-finder-selectboxes',
    previewComponent: 'sw-cms-preview-top-finder-selectboxes',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        sizingMode: 'boxed'
    },
    slots: {
        main: 'text'
    }
});